import { render, staticRenderFns } from "./MyBookingView.vue?vue&type=template&id=28fd7dc0&scoped=true"
import script from "./MyBookingView.vue?vue&type=script&lang=ts"
export * from "./MyBookingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd7dc0",
  null
  
)

export default component.exports